import type { Traversal } from 'arktype';

type WorkloadFields = { workloadHoursPerDay?: number | null; workloadPercent?: number | null };

export function workloadNarrow(data: WorkloadFields, ctx: Traversal): boolean {
  const hasHours = data.workloadHoursPerDay != null;
  const hasPercent = data.workloadPercent != null;
  if (hasHours !== hasPercent) return true;

  return ctx.reject({
    expected: 'exactly one of workloadHoursPerDay or workloadPercent',
    actual: hasHours ? 'both provided' : 'neither provided',
  });
}
